import { styled } from 'styles';

export const StyledTimeline = styled.div``;

StyledTimeline.displayName = 'Timeline';
